import { ReactComponent as WisdomSvg } from "shared/assets/WisdomLogo.svg";
import { EqualWebButton } from "UIPalette/EqualWebButton/EqualWebButton";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { Outlet } from "react-router-dom";

export const LoginLayout = ({ renderWisdomLogo = true }: { renderWisdomLogo?: boolean }) => {
  const { isMobileApp, insetPadding } = useMobilePlatform();
  return (
    <main style={(isMobileApp && insetPadding) ? {
      paddingTop: insetPadding.top + "px",
      paddingBottom: insetPadding.bottom + "px",
    } : undefined} role="main">
      <div className="absolute w-full h-full">
        <div className="absolute h-10 right-2">
          <EqualWebButton />
        </div>
        <div className="flex items-center justify-center min-h-screen py-10">
          <div className="flex flex-col lg:flex-row items-center lg:justify-between gap-10 lg:gap-32">
            {renderWisdomLogo && <WisdomSvg width={250} />}
            <div className="w-80">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
